import React from 'react';
import TabBar from './tab_bar';

export default function VolumeTabBar(props) {
  const { style, volumeId } = props;
  const tabs = [
    { value: 'detail', text: 'Detail', url: `/volume/${volumeId}` },
    {
      value: 'permissions',
      text: 'Permissions',
      url: `/volume/${volumeId}/permission`,
    },
    { value: 'audit', text: 'Audit Log', url: `/volume/${volumeId}/audit` },
    { value: 'metrics', text: 'Metrics', url: `/volume/${volumeId}/metric` },
  ];
  return <TabBar style={style} list={tabs} />;
}
